import React from 'react'
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

const CategoryButtons = ({setChosenCategory, chosenCategory, categories}) => {
    return (
          <ButtonGroup  variant="contained" disableElevation className="category-button-group">
              <Button onClick={() => setChosenCategory("All")} className={chosenCategory === "All" ? "category-selected" : "category-button"} >All</Button>
              {categories.map(category => {
                  if (category.title === chosenCategory){
                      return <Button onClick={() => setChosenCategory(category.title)} className="category-selected">{category.title}</Button>
                  } else {
                      return <Button onClick={() => setChosenCategory(category.title)} className="category-button">{category.title}</Button>
                  }         
              })}
          </ButtonGroup>
    )
}

export default CategoryButtons